import React from 'react';

const NoClienteSeleccionado = ({ tipoVista = 'sku' }) => {
  const getIcono = () => {
    return tipoVista === 'competencias' ? 'fa-link' : 'fa-search';
  };

  const getTitulo = () => {
    return tipoVista === 'competencias' 
      ? 'Selecciona un cliente para ver sus competencias'
      : 'Selecciona un cliente para ver sus productos';
  };

  const getDescripcion = () => {
    return 'Busca y selecciona un cliente del buscador superior';
  };

  return (
    <div className="no-cliente-seleccionado">
      <div className="text-center py-5">
        <i className={`fas ${getIcono()} fa-3x text-muted mb-3`} style={{color: '#F2A71C'}}></i>
        <h5 className="text-muted">{getTitulo()}</h5>
        <p className="text-muted">{getDescripcion()}</p>
      </div>
    </div>
  );
};

export default NoClienteSeleccionado;
